module.exports = __webpack_public_path__ + "5349d5ed9471faf858b203263720bc18.svg";